import React, { useEffect, useState } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './../../styles/admin/ventas_view.css';
import * as globals from './../../components/GlobalScripts.js';

const Admin_ventas_view = () => {
    let path_api = localStorage.getItem('path_api');
    const { id } = useParams();
    const navigate = useNavigate();

    const [venta, setVenta] = useState(null);

    useEffect(() => {
        loadVenta();
    }, []);

    const loadVenta = () => {
        axios.post(`${path_api}/admin/venta_detalle.php`, {
            rute: globals.getRuteBackend(),
            session_id: globals.get_session_id(),
            keylogin: globals.get_keylogin(),
            id: id
        })
        .then(response => {
            if (response.data.mensaje === "success") {
                setVenta(response.data.venta);
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se pudo cargar la información de la venta",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        })
        .catch(() => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar la información de la venta",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const returnPage = () => {
        navigate(`/admin/ventas`);
    };

    if (!venta) {
        return null;
    }

    return (
        <div className="container-venta-view">
            <h2>Detalles de la venta #{id}</h2>
            
            <div className="actions">
                <button onClick={returnPage} className="cancel">Regresar</button>
            </div>
            
            <div className="venta-details">
                <div className="venta-field">
                    <label>Entorno:</label>
                    <span>{venta.type_sell}</span>
                </div>
                <div className="venta-field">
                    <label>Orden:</label>
                    <span>{venta.id}</span>
                </div>
                <div className="venta-field flex-column gap-10">
                    <label>ID Stripe:</label>
                    <span>{venta.id_payment}</span>
                </div>
                <div className="venta-field flex-column gap-10">
                    <label>Keylogin:</label>
                    <Link to={`/admin/clientes/${venta.keylogin}`}>{venta.keylogin}</Link>
                </div>
                <div className="venta-field flex-column gap-10">
                    <label>Descripción:</label>
                    <span>{venta.descripcion}</span>
                </div>
                <div className="venta-field">
                    <label>Valor:</label>
                    <span>{venta.value}</span>
                </div>
                <div className="venta-field">
                    <label>Divisa:</label>
                    <span>{venta.divisa}</span>
                </div>
                <div className="venta-field">
                    <label>Estado de Pago:</label>
                    <span>{venta.payment_status}</span>
                </div>
                <div className="venta-field">
                    <label>Fecha de Creación:</label>
                    <span>{venta.createAt}</span>
                </div>
                <div className="venta-field flex-column gap-10">
                    <label>Carrito:</label>
                    <pre>
                        {venta.cart && typeof venta.cart === 'string'
                            ? JSON.stringify(JSON.parse(venta.cart), null, 2)
                            : JSON.stringify(venta.cart, null, 2)}
                    </pre>
                </div>

                <div className="venta-field flex-column gap-10">
                    <label>Información Adicional (JSON):</label>
                    <pre>{JSON.stringify(venta.json_info, null, 2)}</pre>
                </div>
            </div>
        </div>
    );
};

export default Admin_ventas_view;
